export const COLORS = {
  green: "#437f55",
  light_green: "#e8f5ee",
  primary: "#437f55",
  darkGreen: "#253E2C",
  lightGreen: "#0B915933",
  success: "#437f55",
  green_300: "#28A745",
  green_250: "#0B9159",
  green_400: "#055a17",
  danger: "#c70013",
  red: "#f40000",
  deepRed: "#780305",
  pink: "#F8E0E2",
  dark: "#333",
  dark_250: "#5A5A5A",
  muted_dark_250: "#303030",
  black: "#000000",
  deepDark: "#000000de",
  white: "#fff",
  white_170: "#ffffff2b",
  grey: "#f5f5f5",
  light_grey_100: "#f0f0f0",
  border_grey: "#dddddd",
  light_gray_50: "#F9F9F9",
  blue: "#00639d",
  skyBlue: "#d9e8f1",
  light_blue: "#007BFF",
  deepBlue: "#063153",
  purple: "#201C47",
  deepGray: "#667085",
  darkgrey: "#B5B5B5",
  lightgray: "#1F2937",
  dimgrey: "#696969",
  overlay_30: "#DEE2E6",
  overlay_40: "#3D3D3D",
  overlay_50: "#343a40",
  overlay_060: "#0000000F",
  overlay_100: "#8181814C",
  overlay_150: "#00000026",
  overlay_200: "#00000033",
  overlay_300: "#0000004C",
  overlay_040: "#00000001",
  amber: "#f59e0b",
  navyBlue: "#1a3a5c",
  grey_500: "#808080",
  amber_100: "#fef3c7",
  amber_700: "#b45309",
  amber_800: "#92400e",
  purple_100: "#ede9fe",
  white_overlay_55: "rgba(255, 255, 255, 0.55)",
  violet: "#8b5cf6",
  red_400: "#ef4444",
  cyan: "#06b6d4",
  lime: "#84cc16",
  orange: "#f97316",
  text_primary: "#344054",
  success_bg: "#E8F5E9",
  text_secondary: "#6B7280",
  text_body: "#383838",
  label_gray: "#7F8692",
};
